define(
    'viewmodels/secured/shares/context',[
        "durandal/app",
        "viewmodels/ViewModel",
        "providers/dataprovider"
    ],
    function (app, ViewModel, dataProvider) {
        var vm = new ViewModel();

        //var _promise1 = null;

        vm.loadForSharedDocuments = function (lastdays, isMy) {
            var d = $.Deferred();

            dataProvider.documents
            .getSharedDocuments(lastdays, isMy)
            .done(function (result) {
                var data = _.map(result, function (itm) {
                    
                    itm.expiry = moment(itm.expiry).isValid() ? kendo.toString(kendo.parseDate(itm.expiry), "g") : itm.expiry;

                    return itm;
                });

                d.resolve(data);
            })
            .fail(function (e) {
                d.reject(e);

                console.error(e);
            });

            return d.promise();
        };
        vm.loadForSharedDocumentDetails = function (id) {
            var d = $.Deferred();

            //if (_promise1 == null) {
            //    _promise1 = d;

                dataProvider.documents
                .getSharedDocumentDetails(id)
                .done(function (data) {
                    //data.documents = _.map(data.documents, function (itm) {
                    //    itm.recipients = _.map(itm.recipients, function (recipient) {
                    //        if (recipient.downloaded) {
                    //            try {
                    //                var zz = kendo.toString(recipient.downloaded, "u");
                    //                var d2 = kendo.toString(kendo.parseDate(recipient.downloaded), 'MMM-dd-yy hh:mm tt') + " " + zz.substring(zz.length - 6, zz.length);
                    //                recipient.downloaded = new Date(d2);
                    //            }
                    //            catch (e) {
                    //                console.error(e);
                    //            }
                    //        }
                    //        return recipient;
                    //    });
                    //    return itm;
                    //});

                    //data.recipients = _.map(data.recipients, function (itm) {
                    //    itm.documents = _.map(itm.documents, function (document) {
                    //        if (document.downloaded) {
                    //            try {
                    //                var zz = kendo.toString(document.downloaded, "u");
                    //                var d2 = kendo.toString(kendo.parseDate(document.downloaded), 'MMM-dd-yy hh:mm tt') + " " + zz.substring(zz.length - 6, zz.length);
                    //                document.downloaded = new Date(d2);
                    //            }
                    //            catch (e) {
                    //                console.error(e);
                    //            }
                    //        }
                    //        return document;
                    //    });
                    //    return itm;
                    //});

                    d.resolve(data);

                    //if (_promise1) {
                    //    _promise1.resolve(data);
                    //}
                })
                .fail(function (e) {
                    d.reject(e);
                    //_promise1.reject(e);

                    console.error(e);
                })
                .always(function () {
                    //_promise1 = null;
                });

            //} else {
            //    _promise1.done(function (data) {
            //        d.resolve(data);
            //    });
            //}

            return d.promise();
        };
        vm.cancelForSharedDocument = function (id) {
            var d = $.Deferred();

            dataProvider.documents
            .cancelSharedDocument(id)
            .done(function () {
                d.resolve();
            })
            .fail(function (e) {
                d.reject(e);

                console.error(e);
            });

            return d.promise();
        };

        return vm;
    });
